import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
export function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  const [showReturns, setShowReturns] = useState(false);
  const {
    language
  } = useLanguage();
  const t = translations[language].footer;
  return <footer className="py-6 bg-black border-t border-gray-800 text-center text-gray-400" data-id="element-179">
      <div className="max-w-5xl mx-auto px-4" data-id="element-180">
        {/* Copyright & Author Rights Disclaimer */}
        <div className="mb-6 pb-6 border-b border-gray-800" data-id="element-181">
          <h3 className="text-base font-semibold text-gray-300 mb-3" data-id="element-182">
            {t.copyright}
          </h3>
          <div className="text-xs text-gray-400 space-y-2 max-w-3xl mx-auto text-left md:text-center" data-id="element-183">
            <p data-id="element-184">{t.copyrightText1}</p>
            <p data-id="element-185">{t.copyrightText2}</p>
            <p data-id="element-186">{t.copyrightText3}</p>
          </div>
        </div>
        <div className="flex justify-center items-center gap-6 text-sm" data-id="element-187">
          <button onClick={() => setShowTerms(true)} className="hover:text-teal-300 transition-colors" data-id="element-188">
            {t.terms}
          </button>
          <button onClick={() => setShowReturns(true)} className="hover:text-teal-300 transition-colors" data-id="element-189">
            {t.returns}
          </button>
        </div>
        <p className="mt-4 text-xs" data-id="element-190">
          © {new Date().getFullYear()} {t.allRights}
        </p>
      </div>
      {/* Terms & Policies Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4 overflow-y-auto" data-id="element-191">
          <div className="bg-gradient-to-br from-teal-950 to-black border border-teal-800/50 rounded-xl p-6 md:p-8 max-w-2xl w-full max-h-[80vh] overflow-y-auto" data-id="element-192">
            <div className="flex justify-between items-center mb-4" data-id="element-193">
              <h2 className="text-xl md:text-2xl font-bold text-teal-300" data-id="element-194">
                {t.termsModal.title}
              </h2>
              <button onClick={() => setShowTerms(false)} className="text-gray-400 hover:text-white" data-id="element-195">
                <XIcon className="w-6 h-6" data-id="element-196" />
              </button>
            </div>
            <div className="space-y-4 text-gray-300 text-sm md:text-base" data-id="element-197">
              {t.termsModal.sections.map((section, index) => <div key={index} data-id="element-198">
                  <h3 className="font-bold text-teal-200" data-id="element-199">{section.title}</h3>
                  <p data-id="element-200">{section.content}</p>
                </div>)}
            </div>
          </div>
        </div>}
      {/* Returns Modal */}
      {showReturns && <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4 overflow-y-auto" data-id="element-201">
          <div className="bg-gradient-to-br from-teal-950 to-black border border-teal-800/50 rounded-xl p-6 md:p-8 max-w-2xl w-full max-h-[80vh] overflow-y-auto" data-id="element-202">
            <div className="flex justify-between items-center mb-4" data-id="element-203">
              <h2 className="text-xl md:text-2xl font-bold text-teal-300" data-id="element-204">
                {t.returnsModal.title}
              </h2>
              <button onClick={() => setShowReturns(false)} className="text-gray-400 hover:text-white" data-id="element-205">
                <XIcon className="w-6 h-6" data-id="element-206" />
              </button>
            </div>
            <div className="space-y-4 text-gray-300 text-sm md:text-base" data-id="element-207">
              {t.returnsModal.sections.map((section, index) => <div key={index} data-id="element-208">
                  <h3 className="font-bold text-teal-200" data-id="element-209">{section.title}</h3>
                  <p data-id="element-210">{section.content}</p>
                </div>)}
            </div>
          </div>
        </div>}
    </footer>;
}